import { CompanyInfo } from "./company.model"

export class ProjectSaleInfo {
  ProjectSaleId: number
  ProjectSaleCode: string
  ProjectSaleName: string
  ProjectSaleCompanyId: number
  ProjectSaleCompanyCode: string
  ProjectSaleCompanyDisplay: string
  ProjectSaleCompanyGroupCode: string
  ProjectSaleCompanyGroupName: string
  ProjectSaleCompanyDeliveryAddress: string
  ProjectSaleCompanyTaxInvoiceAddress: string
  ProjectGroupMapping: string
  ProjectGroupNameDisplay: string
  ProjectSaleMemberEmpCode: string
  ProjectSaleContactPerson: string
  ProjectSaleContactPersonDisplay: string
  ProjectSaleContactPosition: string
  ProjectSaleContactTel: string
  ProjectSaleContactDate: string
  ProjectSaleType: string
  ProjectSaleTypeDisplay: string
  ProjectSaleTool: string
  ProjectSalePhase: string
  ProjectSalePhaseDisplay: string
  ProjectSaleBudget: number
  ProjectSaleEstimatePrice: number
  ProjectSaleActualPrice: number
  ProjectSaleEstimateTime: number
  PorjectSaleCommission: string
  ProjectStartDealDate: string
  ProjectEndDealDate: string
  ProjectSaleDuePeriod: string
  ProjectSaleRemark: string
  ProjectSaleBa: string
  ProjectSaleDeveloper: string
  ProjectSaleEstimateManday: string
  ProjectSaleStatus: number
  ProjectSaleStatusDisplay: string
  ProjectSaleStatusWorkflowCode: string
  ProjectSaleStatusWorkflowDisplay: string
  ProjectSaleOnHand: string
  ProjectSaleClosedPeriodMonth: string
  ProjectSaleClosedPeriodYear: string
  ProjectSaleSupportTeam: string
  ProjectSaleContactEmail: string
  ProjectSaleCustomerType: string
  ProjectSaleDeliveryAddress: string
  ProjectSaleTaxInvoiceAddress: string
  ProjectSaleCloseDealProgress: string
  ProjectSaleCloseDeaWfstatus: string
  ProjectSaleCloseDealCreateDate: string
  ProjectSaleCloseDeaWfstatusDisplay: string
  ProjectSaleCloseDealCreateBy: string
  ProjectSaleCloseDealCreateByDisplay: string
  ProjectSaleCategoryCode: string
  ProjectSaleCategoryName: string
  ProjectSaleCreateDate: string
  ProjectSaleCreateBy: string
  ProjectSaleDisplayCreateBy: string
  ProjectSaleActiveFlag: string
  ProjectSaleAssignTo: string
  ProjectSaleAssignToDisaply: string
  ProjectSaleAssignBy: string
  ProjectSaleAssignByDisaply: string
  ProjectSaleRequestTypeCode: string
  ProjectSaleRequestTypeDisplay: string
  ProjectSaleUpdateDate: string
  ProjectSaleUpdateBy: string
  ProjectSaleDisplayUpdateBy: string
  ProjectSaleFlagDelete: string
  ProjectSaleYear: string
  ProjectSaleEffortGroupId: number
  ProjectSaleCloseDealComment: string

  ProjectSaleApprovalRequestId: number;
  ProjectSaleCompanyAbbreviation: string;
  ProjectSaleAssignUpdateDate: string;

  ProjectSaleState: string;
  ProjectSaleSubState: string;
  ProjectSaleStateDisplay: string;
  ProjectSaleSubStateDisplay: string;
  ProjectSaleContactPersonPosition: string;
  ProjectAssignBD: string;
  ProjectAssignBDDisaply: string;
  ProjectSaleOriginatortoRequester: string;
  ProjectSaleAssetTypeCode: string;
  ProjectSaleAssetCategoryCode: string;
  ProjectSaleActualPriceRef: number;
  ProjectSaleDeliveryEsitmateDate: string
  ProjectSaleFlagContractRenewal: string

  countTotal: number

  ProjectSaleCustomFilter: ProjectSaleCustomFilter;
  ProjectSaleTeamCode: string;
  ProjectSaleTeamCodeDisplay: string;

  rowOFFSet: number;
  rowFetch: number;

  ProjectSaleChannelTypeCode: string;
  ProjectSaleChannelTypeCodeDisplay: string;
  ProjectSaleChannelMappingCode: string;
  ProjectSaleChannelMappingCodeDisplay: string;
}

export class ProjectSaleCustomFilter {
  listLead: ProjectSaleInfo[];
  listCompany: CompanyInfo[];

  ProjectSaleEffortEstimation: boolean;

}
